import { Injectable, Injector } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpRequest } from '@angular/common/http';

import * as AlertModels from '../../models/alert/alert';
import { AlertSearchModel } from '../../models/alert/alertSearch';
import { AlertSummaryModel, AlertSummaryListModel } from '../../models/alert/alertSummary';
import { AlertTitleModel, AlertTitleListModel } from '../../models/alert/alertTitle';
// import { environment } from '../../../projects/administration/src/environments/environment';
import { EnvironmentService } from '../../../app/services/environment.service';

@Injectable({
  providedIn: 'root'
})

export class AlertService {

constructor(private httpClient: HttpClient,
            private environment: EnvironmentService
            ) {}

public getSummary() {
  return this.httpClient.get<AlertSummaryListModel>(`${this.environment.getApiURL()}/alert/summary`);

}

  public getList(Search: AlertSearchModel) {
  const httpHeaders = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Cache-Control', 'no-cache');

  Search.RequestSignature = Math.random();

  const options = {headers: httpHeaders};

  return this.httpClient.post<AlertModels.AlertListModel>(`${this.environment.getApiURL()}/alert/list`, Search, options);
}

public get(AlertId: number) {
  return this.httpClient.get<AlertModels.AlertObjectModel>(`${this.environment.getApiURL()}/alert/get/${AlertId}`);
}

public set(Alert: AlertModels.AlertModel) {
  const httpHeaders = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Cache-Control', 'no-cache');

  const options = {headers: httpHeaders};

  return this.httpClient.post<AlertModels.AlertModel>(`${this.environment.getApiURL()}/alert/set`, Alert, options);
}

public getTitleDictionary() {
  return this.httpClient.get<AlertTitleListModel>(`${this.environment.getApiURL()}/alert/titles`);
}

}
